module.exports = __webpack_public_path__ + "static/img/logo_new.2e06566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_new.png
// module id = +pHS
// module chunks = 1